import { Utils } from '@pacem/pacem-core';
import { STORAGE_GROUP_INDEX_LINE, STORAGE_MATERIAL_INDEX } from '../constants';
const DefaultLineMaterialFragmentOptions = {
    outputInstanceIndexLocation: 0,
    outputVertexIndexLocation: 1,
    storageMaterialGroupIndex: STORAGE_GROUP_INDEX_LINE + 1,
    storageMaterialBindingIndex: STORAGE_MATERIAL_INDEX,
};
function adaptWGSLStringArray(array = []) {
    return array.join('\r\n');
}
function adaptWGSLModifierStringArray(array = []) {
    let output = '';
    for (let modifier of array) {
        const trimmed = modifier.trim();
        if (trimmed.endsWith(';')) {
            output += (trimmed + '\r\n');
        }
        else {
            output += `output = ${trimmed};\r\n`;
        }
    }
    return output;
}
export function getLineMaterialFragmentWgsl(extensions = {}, options = DefaultLineMaterialFragmentOptions) {
    const opts = Utils.extend({}, DefaultLineMaterialFragmentOptions, options);
    const definitions = adaptWGSLStringArray(extensions.definitions), bindings = adaptWGSLStringArray(extensions.bindings), modifiers = adaptWGSLModifierStringArray(extensions.modifiers);
    return `// definitions
${definitions}

// bindings
@group(${options.storageMaterialGroupIndex}) @binding(${options.storageMaterialBindingIndex}) var<storage, read> vertexColors: array<vec4f>;
${bindings}

fn getVertexColor(index: u32) -> vec4f {
    let numColors = arrayLength(&vertexColors);
    let vertexColorIndex = index % numColors;
    return vertexColors[vertexColorIndex];
}

@fragment fn main (
    @builtin(position) position: vec4f,                                                 // clip-space position
    @location(${opts.outputInstanceIndexLocation}) @interpolate(flat) instance: u32,    // instance index
    @location(${opts.outputVertexIndexLocation}) @interpolate(flat) index: u32          // vertex index
) -> @location(0) vec4f {
    var output = getVertexColor(index);

    // modifiers
    ${modifiers}

    return output;
}`;
}
